import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
    Block,
    FlexDiv,
    palette,
    TextDefault,
    ThemedButton,
} from '@awarego-ui/components';
import HeaderSection from '../../components/header/HeaderSection';
import SubHeaderText from '../../components/header/SubHeaderText';
import SubHeaderComponentsList from '../../components/header/SubHeaderComponentsList';
import { useStores } from '../../hooks/use-stores';
import AwarePhishSubNav from './AwarePhishSubNav';

const Metrics = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
    margin-top: 8px;
`;

const Metric = styled(Block)`
    padding: 16px;
`;

const MetricLabel = styled.div`
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${palette.graphite.charcoal};
`;

const MetricValue = styled.div`
    font-size: 28px;
    font-weight: 700;
    color: ${palette.graphite.heavyMetal};
    margin-top: 4px;
`;

function AwarePhishOverview() {
    const navigate = useNavigate();
    const { store, awarePhishStore } = useStores();
    const { currentCompany } = store;
    const { summary, loadingSummary } = awarePhishStore;

    useEffect(() => {
        if (currentCompany && currentCompany.company_id) {
            awarePhishStore.loadSummary(currentCompany.company_id);
        }
    }, [currentCompany && currentCompany.company_id]);

    return (
        <Container className="manager-content">
            <Helmet>
                <title>AwarePHISH</title>
            </Helmet>
            <HeaderSection
                heading={'AwarePHISH'}
                subHeadings={
                    <SubHeaderComponentsList>
                        <SubHeaderText
                            text={
                                'Phishing simulations for your organisation (beta).'
                            }
                        />
                    </SubHeaderComponentsList>
                }
                buttons={
                    <ThemedButton
                        text="+ New simulation"
                        mode={'primary'}
                        onClick={() =>
                            navigate('/aware-phish/campaigns/new')
                        }
                        $noWrap
                    />
                }
            />
            <AwarePhishSubNav active="overview" />

            <Metrics>
                <Metric>
                    <MetricLabel>Simulations sent</MetricLabel>
                    <MetricValue>
                        {loadingSummary ? '…' : (summary && summary.sent) || 0}
                    </MetricValue>
                </Metric>
                <Metric>
                    <MetricLabel>Fail rate</MetricLabel>
                    <MetricValue>
                        {loadingSummary
                            ? '…'
                            : `${(summary && summary.failRate) || 0}%`}
                    </MetricValue>
                </Metric>
                <Metric>
                    <MetricLabel>Reported</MetricLabel>
                    <MetricValue>
                        {loadingSummary
                            ? '…'
                            : `${(summary && summary.reportedRate) || 0}%`}
                    </MetricValue>
                </Metric>
            </Metrics>

            <Block padding="16" column style={{ marginTop: 16 }}>
                <FlexDiv>
                    <TextDefault lighter>
                        Create a simulation from the Simulations tab: name,
                        recipients, and launch time. Results update as employees
                        receive, open, click or report the mail.
                    </TextDefault>
                </FlexDiv>
            </Block>
        </Container>
    );
}

export default observer(AwarePhishOverview);
